import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {KarmaContent} from '../karma-content.model';

@Component({
  selector: 'app-dislike-list',
  templateUrl: './dislike-list.component.html',
  styleUrls: ['./dislike-list.component.css']
})
export class DislikeListComponent implements OnInit {

  listKarma: KarmaContent[] = [];

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() { 

  }
  
  action(list: KarmaContent[]) {
    this.listKarma = list || [];
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/dislike-list/dislike-list.component.ts